module.exports = __webpack_public_path__ + "static/media/rest.776c3dde.png";